<app-preloader *ngIf="isLoading"></app-preloader>
<!-- Modal Editar Marca -->
<div class="modal">
    <a class="close" (click)="closeModal()">Cerrar</a>
    <h1>{{ isEdit ? 'Editar Marca' : 'Nueva Marca' }}</h1>
    <div class="editarMarca">
        <form [formGroup]="form" (ngSubmit)="create()">
            <div class="customWrapper">
                <div class="controlWrapper">
                    <label>Nombre<span class="required">*</span></label>
                    <div>
                        <input formControlName="name" type="text" />
                    </div>
                </div>
                <!--<div class="controlWrapper">
                    <label>Código<span class="required">*</span></label>
                     
                    <div>
                        <input formControlName="brandCode" type="number" />
                    </div>
                    
                </div>-->
                <div>
                    <label class="switch gapTop">
                        <input formControlName="enabled" type="checkbox" />
                        <span class="knob"></span>
                        <span class="base"></span>
                        <span class="description">Habilitado</span>
                    </label>
                </div>
            </div>
            <!-- Acciones para modal condición -->
            <div class="actions">
                <div class="wrapper">
                    <button type="button" class="secondary" (click)="closeModal()">Cancelar</button>
                    <button type="submit" class="primary">
                        {{ isEdit ? 'Confirmar' : 'Crear' }}
                      </button>
                </div>
            </div>
        </form>
    </div>
</div>
